import styled from 'styled-components'

import type { ClassNameProps } from '@root/shared/react'

type DataTableHeaderSortingProps = {
  sorting: 'asc' | 'desc' | undefined
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
  size?: number
} & ClassNameProps

export const DataTableHeaderSorting: React.FC<DataTableHeaderSortingProps> = ({
  className,
  sorting,
  onClick,
  size = 16,
}) => {
  return (
    <Root className={className} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.65996 11.0138C7.66512 11.187 7.7375 11.3514 7.86178 11.4721L10.5284 14.1388C10.6535 14.2638 10.823 14.334 10.9998 14.334C11.1766 14.334 11.3461 14.2638 11.4712 14.1388L14.1378 11.4721C14.2018 11.4107 14.2529 11.3371 14.2881 11.2557C14.3233 11.1743 14.3419 11.0867 14.3428 10.998C14.3437 10.9093 14.3269 10.8213 14.2933 10.7392C14.2598 10.6571 14.2102 10.5825 14.1475 10.5197C14.0848 10.457 14.0102 10.4074 13.9281 10.3739C13.846 10.3404 13.758 10.3236 13.6693 10.3245C13.5806 10.3254 13.493 10.344 13.4115 10.3792C13.3301 10.4144 13.2565 10.4654 13.1951 10.5294L11.6665 12.0581L11.6665 2.33411C11.6677 2.24577 11.6514 2.15806 11.6185 2.07608C11.5855 1.99411 11.5366 1.91949 11.4746 1.85658C11.4125 1.79367 11.3386 1.74371 11.2571 1.70961C11.1756 1.67551 11.0882 1.65795 10.9998 1.65795C10.9115 1.65795 10.824 1.67551 10.7425 1.70961C10.661 1.74371 10.5871 1.79367 10.525 1.85658C10.463 1.91949 10.4141 1.99411 10.3811 2.07608C10.3482 2.15806 10.3319 2.24577 10.3331 2.33411L10.3331 12.0581L8.80449 10.5294C8.71085 10.4331 8.59029 10.3673 8.45861 10.3407C8.32693 10.314 8.19027 10.3278 8.06655 10.3801C7.94282 10.4325 7.8378 10.521 7.76525 10.6341C7.6927 10.7472 7.656 10.8795 7.65996 11.0138Z"
          fill={
            sorting === 'desc'
              ? `var(--sorting-active-color)`
              : `var(--sorting-inactive-color)`
          }
        />
        <path
          d="M1.66016 5.00808C1.66032 5.14065 1.7 5.27016 1.77412 5.38006C1.84825 5.48997 1.95346 5.57529 2.0763 5.62511C2.19915 5.67493 2.33406 5.687 2.46381 5.65978C2.59355 5.63256 2.71223 5.56728 2.80469 5.47228L4.33333 3.94363L4.33333 13.6676C4.33208 13.7559 4.3484 13.8436 4.38135 13.9256C4.41429 14.0076 4.4632 14.0822 4.52523 14.1451C4.58726 14.208 4.66117 14.258 4.74268 14.2921C4.82418 14.3262 4.91165 14.3437 5 14.3437C5.08835 14.3437 5.17582 14.3262 5.25732 14.2921C5.33883 14.258 5.41274 14.208 5.47477 14.1451C5.5368 14.0822 5.58571 14.0076 5.61865 13.9256C5.6516 13.8436 5.66792 13.7559 5.66667 13.6676L5.66667 3.94363L7.19531 5.47228C7.25674 5.53626 7.33032 5.58734 7.41174 5.62253C7.49316 5.65772 7.58078 5.67631 7.66948 5.67722C7.75817 5.67812 7.84615 5.66132 7.92827 5.62779C8.01039 5.59426 8.08499 5.54469 8.14771 5.48197C8.21043 5.41925 8.26001 5.34465 8.29353 5.26253C8.32706 5.18041 8.34386 5.09243 8.34296 5.00373C8.34206 4.91504 8.32347 4.82742 8.28828 4.746C8.25309 4.66458 8.202 4.591 8.13802 4.52957L5.47135 1.8629C5.34632 1.73792 5.17678 1.66772 5 1.66772C4.82322 1.66772 4.65367 1.73792 4.52865 1.8629L1.86198 4.52957C1.79804 4.59177 1.74723 4.66617 1.71256 4.74837C1.67789 4.83056 1.66007 4.91888 1.66016 5.00808Z"
          fill={
            sorting === 'asc'
              ? `var(--sorting-active-color)`
              : `var(--sorting-inactive-color)`
          }
        />
      </svg>
    </Root>
  )
}

const Root = styled.div`
  --sorting-active-color: var(--text-12);
  --sorting-inactive-color: var(--text-10);
  cursor: pointer;
  display: grid;
`
